import React, { ReactElement, useContext, useEffect, useState } from 'react';
import styles from './AppChartArea.module.less';
import { Area } from '@ant-design/charts';
import { ChartsContext } from '../core/context/ChartsContext';

export type AppChartAreaProps = {
    config: any;
    data: any[];
};

function AppChartArea({ config, data }: AppChartAreaProps): ReactElement {
    const [chartConfig, setChartConfig] = useState<any>({
        ...config,
        meta: {
            xValue: {
                tickMethod: 'time',
            },
        },
    });

    const chartsContext = useContext(ChartsContext);

    useEffect(() => {
        if (chartConfig) {
            if (chartsContext.chartRange === '1w') {
                setChartConfig({
                    ...chartConfig,
                    xAxis: {
                        type: 'time',
                        mask: 'YYYY-MM-DD',
                    },
                    meta: {
                        xValue: {
                            tickMethod: 'time',
                            tickInterval: 60 * 60 * 24,
                        },
                    },
                });
            } else {
                setChartConfig({
                    ...chartConfig,
                    xAxis: {
                        type: 'time',
                        mask: 'HH:mm',
                    },
                    meta: {
                        xValue: {
                            tickMethod: 'time',
                        },
                    },
                });
            }
        }
    }, [chartsContext.chartRange]);

    return (
        <div className={styles.AppChartArea}>
            <Area {...chartConfig} data={data} />
        </div>
    );
}

export default AppChartArea;
